import { useEffect, useState } from "react";
import { NAV_ITEMS } from "../data/reels";

export const Nav = () => {
  const [active, setActive] = useState("hello");

  useEffect(() => {
    const sections = NAV_ITEMS.map((n) => document.getElementById(n.id)).filter(Boolean);
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px", threshold: 0 }
    );
    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setActive(id);
  };

  return (
    <div className="fixed top-3 left-0 right-0 z-50 flex justify-center px-3 pointer-events-none">
      <nav
        data-testid="main-nav"
        className="pointer-events-auto flex items-center gap-1 px-1.5 py-1.5 rounded-full bg-black/95 backdrop-blur-md border border-white/5 shadow-[0_12px_40px_-12px_rgba(0,0,0,0.5)]"
        style={{ maxWidth: "calc(100vw - 24px)" }}
      >
        {NAV_ITEMS.map((item) => {
          const isActive = active === item.id;
          return (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => go(item.id)}
              className={`mono text-[11px] sm:text-xs px-3 sm:px-4 py-1.5 sm:py-2 rounded-full transition-all duration-300 whitespace-nowrap ${
                isActive
                  ? "menu-active"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              {item.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
};
